import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from "recharts";
import THEME from "../../../theme";
import { fs } from "../utils/styles";

const geld = (n) => n == null ? "–" : `${n.toFixed(2)} €`;

// Voller Verlauf einer einzelnen BWA-Kennzahl (z.B. Raumkosten) ueber alle hochgeladenen
// Monate - nutzt dieselben Daten, die /finanzen/bwa/trend fuers Uebersichts-Chart schon liefert,
// kein eigener API-Aufruf noetig. Zeigt zusaetzlich die Veraenderung zum Vormonat pro Zeile,
// damit auf einen Blick sichtbar ist, ob/wann sich ein Kostenpunkt geaendert hat.
export default function BwaKategorieVerlauf({ trend, schluessel, onSchliessen }) {
  const serie = trend?.serien?.[schluessel];
  if (!serie) return null;

  const daten = trend.monate.map((label, i) => ({ label, Wert: serie.werte[i] }));

  return (
    <div style={{ ...fs.karte, borderLeft: `4px solid ${THEME.colors.primary}` }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <h3 style={{ color: THEME.colors.text, margin: 0 }}>Verlauf: {serie.bezeichnung}</h3>
        <button style={{ ...fs.btnGray, width: "auto" }} onClick={onSchliessen}>Schließen</button>
      </div>
      <ResponsiveContainer width="100%" height={220}>
        <LineChart data={daten}>
          <CartesianGrid strokeDasharray="3 3" stroke={THEME.colors.border} />
          <XAxis dataKey="label" stroke={THEME.colors.textMuted} fontSize={12} />
          <YAxis stroke={THEME.colors.textMuted} fontSize={12} />
          <Tooltip contentStyle={{ background: THEME.colors.surface, border: `1px solid ${THEME.colors.border}`, color: THEME.colors.text }} />
          <Line type="monotone" dataKey="Wert" stroke={THEME.colors.primary} strokeWidth={2} dot connectNulls />
        </LineChart>
      </ResponsiveContainer>
      <div style={fs.tabelle}>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr><th style={fs.th}>Monat</th><th style={{ ...fs.th, textAlign: "right" }}>Wert</th><th style={{ ...fs.th, textAlign: "right" }}>Veränderung zum Vormonat</th></tr>
          </thead>
          <tbody>
            {daten.map((d, i) => {
              const vorher = i > 0 ? daten[i - 1].Wert : null;
              const veraenderung = (d.Wert != null && vorher != null) ? d.Wert - vorher : null;
              return (
                <tr key={d.label}>
                  <td style={fs.td}>{d.label}</td>
                  <td style={{ ...fs.td, textAlign: "right" }}>{geld(d.Wert)}</td>
                  <td style={{ ...fs.td, textAlign: "right", color: veraenderung == null ? THEME.colors.textMuted : veraenderung > 0 ? THEME.colors.danger : veraenderung < 0 ? THEME.colors.success : THEME.colors.textMuted }}>
                    {veraenderung == null ? "–" : `${veraenderung >= 0 ? "+" : ""}${veraenderung.toFixed(2)} €`}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
